module.exports = __webpack_public_path__ + "media/images/user-guide-1-5ec38573a3d5d1ac0197acf69f7ad8a6.png";